import { Filesystem } from "@capacitor/filesystem";

/** Hosted HTTPS WebViews cannot reliably fetch Capacitor's local-file scheme. */
export async function readNativeFile(path: string): Promise<Blob> {
  try {
    const { data } = await Filesystem.readFile({ path });
    if (data instanceof Blob) return data;
    const binary = atob(data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes]);
  } catch {
    throw new Error("This file could not be opened. Please select it again.");
  }
}
